import { Action } from 'redux';
import { READ_ACTION_TYPES } from './action_types';

export type ReadPeriscopeAction = Action<READ_ACTION_TYPES>;

export function resetAnalysisPeriscope(): ReadPeriscopeAction {
	return { type: READ_ACTION_TYPES.RESET_ANALYSIS_PERISCOPE };
}

export function resetPeriscope(): ReadPeriscopeAction {
	return { type: READ_ACTION_TYPES.RESET_PERISCOPE };
}
